import { CarerPresenter } from '@shared/modules/carers/carer.presenter';
import type { ClientCarerCompatibility } from '@shared/modules/client-carer-compatibility/client-carer-compatibility';
import { QualificationPresenter } from '@shared/modules/qualifications/qualification.presenter';
import { Presenter } from '@shared/presenters/presenter';

export class ClientCarerCompatibilityPresenter extends Presenter<ClientCarerCompatibility> {

    get carer() {
        return this.present('carer.data', CarerPresenter);
    }

    get qualification() {
        return this.present('qualification.data', QualificationPresenter);
    }

    get type() {
        return this._get('type', () => ({
            warn: 'Warn',
            exclude: 'Excluded',
            prefer: 'Preferred',
            whitelisted: 'Only'
        }[this.data.type]));
    }

    get gender(): string {
        return this._get('gender', () => ({
            m: 'Male',
            f: 'Female'
        }[this.data.data.gender]));
    }

    get message() {
        return this._get('message', () => {
            if (this.data.type === 'prefer') {
                return `Preferred${this.data.reason ? (': ' + this.data.reason) : ''}`;
            }

            if (this.data.type === 'whitelisted') {
                return `Whitelisted${this.data.reason ? (': ' + this.data.reason) : ''}`;
            }

            if (this.data.reason) {
                return `Incompatible: ${this.data.reason}`;
            }

            if (this.data.type === 'exclude') {
                return 'Incompatible: Excluded';
            }

            return 'Incompatible';
        });
    }
}
